import React from 'react';
import { MESSAGE_MAX } from '../../data/program';
import { useProto } from '../../contexts/PrototypeContext';
import { FieldTag } from '../shared/FieldTag';
export function VolunteerMessageField() {
  const {
    state,
    actions
  } = useProto();
  const len = state.config.message.length;
  const near = len >= MESSAGE_MAX - 10;
  return <div data-id="element-191" data-mp="2fx29zelv6i1l">
      <div className="flex items-center gap-2" data-id="element-192" data-mp="2fxc4nfhutddm">
        <label htmlFor="vrd-msg" className="font-medium text-connect-ink" data-id="element-193" data-mp="1s6gawctu883q">
          Volunteer Registration Message <span className="font-normal text-connect-muted" data-id="element-194" data-mp="1n8od526ihrrm">(optional)</span>
        </label>
        <FieldTag kind="editable" data-id="element-195" data-mp="20ztc02222g0w" />
      </div>
      <p className="mt-0.5 text-sm text-connect-muted" data-id="element-196" data-mp="210l0yu15dfi7">An encouraging note shown below the discount offer.</p>
      <div className="relative mt-2" data-id="element-197" data-mp="1w6gusczphbi6">
        <textarea id="vrd-msg" rows={3} maxLength={MESSAGE_MAX} value={state.config.message} onChange={e => actions.updateConfig({
        message: e.target.value
      })} placeholder="e.g. We'd love to have you on the team! No experience needed." aria-describedby="vrd-msg-help vrd-msg-count" className="w-full resize-none rounded-md border border-gray-300 px-3 py-2.5 pb-7 text-sm text-connect-ink outline-none focus:border-connect-blue focus:ring-1 focus:ring-connect-blue" data-id="element-198" data-mp="18ih5lhi1lt5p" />
        <span id="vrd-msg-count" aria-live="polite" className={`absolute bottom-3 right-3 rounded bg-white px-1 text-xs tabular-nums ${near ? 'font-medium text-status-lowInk' : 'text-connect-muted'}`} data-id="element-199" data-mp="21p9yr7ymc1ly">
          {len} / {MESSAGE_MAX}
        </span>
      </div>
      <p id="vrd-msg-help" className="mt-1.5 text-xs text-connect-muted" data-id="element-200" data-mp="1dzpiiwtunigd">
        The volunteer registration discount amount will display automatically. You do not need to include it in your message.
      </p>
    </div>;
}